import { useState } from 'react'
import { KIT_BASE, kitCore, kitRegions, regionFile } from '../data/kit'

const Check = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} aria-hidden="true">
    <path d="M4 12.5l5 5L20 6.5" />
  </svg>
)

// The kit is handed over on the page the moment someone asks for it. No email is
// collected or sent, so there is nothing to store and nothing that can fail silently.
export default function Newsletter() {
  const [region, setRegion] = useState('')
  const [ready, setReady] = useState(false)

  const chosen = kitRegions.find((r) => r.key === region)
  const files = chosen
    ? [...kitCore, { file: regionFile(chosen.key), label: `Region Playbook: ${chosen.label}` }]
    : kitCore

  function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!region) return
    setReady(true)
    const w = window as unknown as { dataLayer?: object[] }
    w.dataLayer?.push({ event: 'kit_unlocked', kit_region: region })
  }

  return (
    <section className="news" id="newsletter">
      <div className="wrap">
        <div className="news-in">
          <div>
            <h2>The Free Starter Kit</h2>
            <p className="nsub">Three printable PDFs, yours instantly. No email, no signup, nothing to wait for.</p>
            <div className="checklist">
              <div>
                <Check /> The 2-Week Water &amp; Food Baseline (PDF)
              </div>
              <div>
                <Check /> Home Hardening starter checklist (PDF)
              </div>
              <div>
                <Check /> Region playbook for your area (PDF)
              </div>
            </div>
          </div>
          {ready ? (
            <div className="nform" aria-live="polite">
              <div className="nlab label">Your kit is ready</div>
              <h3>Download the Starter Kit</h3>
              <ul className="nkit">
                {files.map((f) => (
                  <li key={f.file}>
                    <a className="btn" href={`${KIT_BASE}${f.file}`} download>
                      <span>{f.label}</span>
                      <span aria-hidden="true">↓</span>
                    </a>
                  </li>
                ))}
              </ul>
              <button type="button" className="nlink" onClick={() => setReady(false)}>
                Pick a different region
              </button>
              <p className="fine">Print them, fill in the blanks, keep a copy somewhere the power can't take. Educational content only, not medical, legal, or financial advice.</p>
            </div>
          ) : (
            <form className="nform" onSubmit={onSubmit}>
              <div className="nlab label">Instant download</div>
              <h3>Get the Starter Kit</h3>
              <div className="nfield">
                <label className="nsel-lab" htmlFor="kit-region">Where do you live?</label>
                <select id="kit-region" value={region} onChange={(e) => setRegion(e.target.value)} required>
                  <option value="" disabled>
                    Choose your region
                  </option>
                  {kitRegions.map((r) => (
                    <option key={r.key} value={r.key}>
                      {r.label}: {r.blurb}
                    </option>
                  ))}
                </select>
                <button className="btn sig" type="submit" style={{ justifyContent: 'center' }}>
                  Get My Kit →
                </button>
              </div>
              <p className="fine">Free. No email required. Educational content only, not medical, legal, or financial advice.</p>
            </form>
          )}
        </div>
      </div>
    </section>
  )
}
